/*
  This module is responsible for handling ChiliPiper integration through GravityForm confirmation panel.

  How to use :

  In a gravity form confirmation message, add the following code:
  <h3>Thank you for contacting us!</h3>
  <script>
  var chilipiper_data = {
    "firstname": "{First Name:7}",
    "lastname": "{Last Name:8}",
    "email": "{Email:3}",
    [add more fields here]
  }
  if(typeof window._emitter === 'object') {
    window._emitter.emit("ChiliPiper.init", "surfe", "routing-inbound", chilipiper_data);
  }
  </script>

  This will trigger the ChiliPiper integration with the data from the form.
  This could be handled on a confirmation page throught Gravity Forms URL params sent to the confirmation page
  including a similar code block but capturing URL params, not the form data.

*/

import Module from "@modules/module/Module";
import { $ } from "@utils/dom";

export const SELECTOR = `.gform_wrapper`;

class Factory extends Module {
  constructor() {
    super();
    this.initialized = false;
    
    this._onInit = this._onInit.bind(this);
  }

  get name() {
    return "ChiliPiper";
  }

  init() {
    this.element = $(SELECTOR);
    if (!this.element) return;
    this._bindEvents();
  }

  destroy() {
    if(!this.element) return;
    this._unbindEvents();
    this.element = null;
  }

  start() { }
  stop() { }

  _bindEvents() {
    this.emitter.on("ChiliPiper.init", this._onInit);
  }
  _unbindEvents() {
    this.emitter.off("ChiliPiper.init", this._onInit);
  }

  _onInit(cpTenantDomain = '', cpRouterName = '', data = {}) {
    // check first if ChiliPiper is already loaded
    if (window?.ChiliPiper) {
      this._openCalendar(cpTenantDomain, cpRouterName, data);
      return;
    }

    // insert script in page
    const script = document.createElement('script');
    script.src = 'https://js.chilipiper.com/marketing.js';
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      this._openCalendar(cpTenantDomain, cpRouterName, data);
    }
  }

  _openCalendar(cpTenantDomain = '', cpRouterName = '', data = {}) {
    window?.ChiliPiper.submit(cpTenantDomain, cpRouterName, {
      map: true,
      lead: {
        firstname: data?.firstname,
        lastname: data?.lastname,
        email: data?.email,
      },
    });
  }

  // _validateData(data) {
  //   if (!data) return false;
  //   if (!data.firstname) return false;
  //   if (!data.lastname) return false;
  //   if (!data.email) return false;
       // validate email is using gmail, yahoo etc.
  //   const regex = /@gmail|@yahoo|@outlook/g;
  //   if(data.email.match(regex)) return false;
  // }

}

export default Factory;
